import useZendesk from '@components/Zendesk/useZendesk';
import classNames from 'classnames';
import moment from 'moment';
import { FaRegCopyright } from 'react-icons/fa';
import { CARTEDO_LINKS } from '../../../libs/constants/constants';
import { translate } from '../../../state/utils/helper';
import { Nav, NavItem, NavLink } from '../Html';
import './Footer.scss';
const Footer = (props: { isLoginScreen?: boolean }) => {
  const { isLoginScreen } = props;
  const { openZendesk } = useZendesk();
  return (
    <footer
      className={classNames('pb-4 mt-4 pt-4 footer__container', {
        'footer__container--login': isLoginScreen,
      })}
      id="footer-main"
    >
      <div>
        <div className="footer__copyright text-muted">
          <FaRegCopyright className="footer__link" />
          <span className="mx-1 footer__link">{moment().format('YYYY')}</span>
          <a
            className="font-weight-bold"
            href={CARTEDO_LINKS.WEBSITE}
            target="_blank"
            rel="noreferrer"
          >
            {translate('appName')}
          </a>
        </div>
      </div>
      <div>
        <Nav className={classNames('nav-footer justify-content-center justify-content-xl-end')}>
          <NavItem>
            <NavLink target="_blank" className="footer__link" href={CARTEDO_LINKS.PRIVACY_POLICY}>
              {translate('layout.navbar.privacy')}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              target="_blank"
              href={CARTEDO_LINKS.TERMS_AND_CONDITIONS}
              className="footer__link"
            >
              {translate('layout.navbar.terms')}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              target="_blank"
              href="#"
              className="footer__link"
              data-acsb-custom-trigger="true"
            >
              {translate('layout.navbar.accessibility')}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              target="_blank"
              href="#"
              onClick={(e: React.MouseEvent) => {
                e.preventDefault();
                openZendesk();
              }}
              className="footer__link"
            >
              {translate('layout.navbar.help')}
            </NavLink>
          </NavItem>
        </Nav>
      </div>
    </footer>
  );
};

export default Footer;
